import React from 'react';

const ServicesOneABoutObstetricGyanecology = () => {
   return (
      <>
         <section className="about-area pt-120 pb-90">
            <div className="container">
               <div className="row ">
                  <div className="col-xl-6 col-lg-6 col-md-12">
                     <div className="section-title section-title-m-0 pos-rel mb-50 text-end">
                        <div className="section-icon">
                           <img className="section-back-icon back-icon-right" src="img/section/section-back-icon.png" alt="" />
                        </div>
                        <div className="section-text section-text-small pos-rel">
                           <h5>health care facility</h5>
                           <h1>Would you rather stay at home than go into a health care facility?</h1>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-12">
                     <div className="facalty-text mb-50">
                        <p>
                           With every stage of woman's life, comes changes in her body and different health issues are faced at different stages. The department of Obstetrics & Gynecology at Octavia hospital offers comprehensive care for woman. Our renowned specialist offer their expert opinion on preventive measures, ensure accurate diagnosis and provide suitable treatment. Our doctors are highly experienced and skilled to cater to woman of different age groups - from teenagers to senior citizens.
                           <br />
                           Our outpatient and inpatient unit is equiped to diagnose and treat a range of gynecological conditions. Our department is supported by well equiped micro biological & pathological lab and radiological department and includes surgery from simple minimally invasive surgeries to complex open surgeries.
                        </p>
                     </div>
                  </div>
               </div>
               {/* <div className="row">
                  <HomeSIngleService icon="1" title="Body Surgery" border_className="service-box-border" />
                  <HomeSIngleService icon="2" title="Dental Care" border_className="service-box-border" />
                  <HomeSIngleService icon="3" title="service-content" border_className="service-box-border" />
                  <HomeSIngleService icon="4" title="Blood Cancer" border_className="service-box-border" />
                  <HomeSIngleService icon="5" title="Neurology Sargery" border_className="service-box-border" />
                  <HomeSIngleService icon="6" title="Allergic Issue" border_className="service-box-border" />
               </div> */}
            </div>
         </section>
      </>
   );
};

export default ServicesOneABoutObstetricGyanecology;